import { render, staticRenderFns } from "./Swaps.vue?vue&type=template&id=71b69a62&scoped=true"
import script from "./Swaps.js?vue&type=script&lang=js&external"
export * from "./Swaps.js?vue&type=script&lang=js&external"
import style0 from "./Swaps.vue?vue&type=style&index=0&id=71b69a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b69a62",
  null
  
)

export default component.exports